import React, { ReactNode } from 'react';
import { Stack } from '@fluentui/react';
import { ContentPane } from 'components';

type Props = {
    children: ReactNode;
};

const NoSidebarLayout = (props: Props) => {
    return (
        <Stack horizontal styles={{ root: { flex: 1, height: '100%', overflow: 'hidden' } }}>
            <ContentPane>{props.children}</ContentPane>
        </Stack>
    );
};

export default NoSidebarLayout;
